<template>
    <b-modal :id="'modal-endereco'" centered :title="'Endereço ' + tipoEndereco" size="lg" @hidden="fecharModal" @shown="aoAbrirModal">
        <b-row style="height:170px;">
            <b-col cols="12" sm="12" >
                <MapaEnderecoAtendimento :coordenadas="coordenadasEndereco()" />
            </b-col>
        </b-row>
       
        <b-col cols="12 lh-18 mt-2" v-html="$func.montarEndereco(dadosEndereco)" />
        
        <div v-if="segundaSaida !== true">
            <b-row class="justify-content-md-center mt-3">
                <b-col sm="12" v-show="geolocationSupported">
                    <b-button block variant="success" :disabled="loading" @click="fetchAddressCoordinate()">
                        <i class="fas fa-map-marker-alt"></i>
                        {{ loading ? `Aguarde ...` : `Usar minha localização` }}
                    </b-button>
                </b-col>
            </b-row>
        </div>

        <b-form id="form-endereco">
            <input type="hidden" id="logradouro" name="logradouro" v-model="dadosEndereco.logradouro"/>
            <input type="hidden" id="numero" name="numero" v-model="dadosEndereco.numero"/>
            <input type="hidden" id="bairro" name="bairro" v-model="dadosEndereco.bairro"/>
            <input type="hidden" id="cidade" name="cidade" v-model="dadosEndereco.cidade"/>
            <input type="hidden" id="estado" name="estado" v-model="dadosEndereco.estado"/>
            <input type="hidden" id="referencia" name="referencia" v-model="dadosEndereco.referencia"/>
            <input type="hidden" id="latitude" name="latitude"  v-model="dadosEndereco.latitude" />
            <input type="hidden" id="longitude" name="longitude"  v-model="dadosEndereco.longitude"/>
        </b-form>

        <template v-slot:modal-footer>
            <button type="button" class="btn btn-default" @click="fecharModal()">
                <i class="fa fa-times" aria-hidden="true"></i> Fechar
            </button>
            <button type="button" 
                class="btn btn-primary" 
                v-if="segundaSaida !== true" 
                :disabled="loading" 
                @click="salvarEndereco()"
            >
                <i class="fa fa-check" aria-hidden="true"></i>
                {{ loading ? 'Aguarde ...' : 'Salvar' }}
            </button>
        </template>

    </b-modal>
</template>

<script>
import MapaEnderecoAtendimento from "@/components/Mapa/MapaEnderecoAtendimento";
import { mapActions } from 'vuex';
import * as locationService from '@/services/location';
import barramentoEndereco from '@/bus/endereco';

const objEndereco = {
    logradouro: "",
    numero: "",
    bairro: "",
    cidade: "",
    estado: "",
    referencia: "",
    latitude: "",
    longitude: "",
};

export default {
    data() {
        return {
            dadosEndereco: {...objEndereco},
            tipoEndereco: '',
            segundaSaida: false,
            tituloModal: '',
            opcoesExibidas: false,
            geolocationSupported: `geolocation` in navigator,
            loading: false,
            corrigir: true
        };
    },
    components: {
        MapaEnderecoAtendimento
    },
    created() {
        barramentoEndereco.$on('editarEndereco', (param) => {
            this.dadosEndereco = param.endereco;
            this.tipoEndereco = param.tipo;
            this.tituloModal = param.tipo;
            this.segundaSaida = param.segundaSaida;
            if (param.segundaSaida === true) {
                this.tipoEndereco += 'SegundaSaida';
                this.tituloModal += 'segunda saída';
            }
            this.$bvModal.show(`modal-endereco`);
            if (Object.prototype.hasOwnProperty.call(param, 'corrigir')) {
                this.corrigir = param.corrigir;
            }
        });
    },
    methods: {
        ...mapActions('Atendimento', ['atualizarEnderecoAtendimento']),
        
        async salvarEndereco () {
            this.loading = true;
            const chave =  `endereco${this.$func.ucWords(this.tipoEndereco)}`;
            let item = {};
            const endereco = this.dadosEndereco;
            let vazio = 0;
            for (const campo in endereco) {
                if (this.$func.isEmpty(endereco[campo])) {
                    vazio++;
                }
                item[campo] = endereco[campo];
            }

            if (Object.keys(item).length == 0 || Object.keys(item).length == vazio) {
                this.loading = false;
                this.alerta('O endereço está vazio');
            } else {
                await this.atualizarEnderecoAtendimento({
                    chave, item
                }).then((data) => {
                    this.loading = false;
                    this.fecharModal();
                    this.alerta(data.message);   
                }).catch(data => {
                    this.loading = false;
                    this.alerta(data.message);   
                });
            }
        },
        async fetchAddressCoordinate() {
            try {
                this.loading = true;
                this.campoEnderecoExibido = false; 
                const address = await locationService.currentAddress();
                this.dadosEndereco = address;

                this.loading = false;
                this.alerta(`Localização de ${this.tipoEndereco} recuperada com sucesso.`);
            } catch (error) {
                this.loading = false;
                this.alerta(error.message);
            }
        },
        exibirCampoEndereco () {
            this.campoEnderecoExibido = !this.campoEnderecoExibido;
            this.loading = false;
        },
        alerta(texto) {
            this.$bvModal.msgBoxOk(texto, {centered: true});
        },
        aoAbrirModal() {
            barramentoEndereco.$emit('centralizarMapa');
        },
        fecharModal() {
            this.campoEnderecoExibido = false;
            this.opcoesExibidas = false;
            this.loading = false;
            this.dadosEndereco = objEndereco;
            this.$bvModal.hide(`modal-endereco`);
            this.corrigir = true;
        },
        coordenadasEndereco() {
            let coordenadas = [];
            if (!this.$func.isEmpty(this.dadosEndereco.latitude) && !this.$func.isEmpty(this.dadosEndereco.longitude)) {
                coordenadas.push({
                    lat: this.dadosEndereco.latitude,
                    long: this.dadosEndereco.longitude
                });
            }
            return coordenadas;
        }
    }
}
</script>